if (!customElements.get('dynamic-size-chart')) {
  class DynamicSizeChart extends HTMLElement {
    constructor() {
      super();
      this.handleVariantClick = this.handleVariantClick.bind(this);
    }

    connectedCallback() {
      this.variantsContainer = this.querySelector('.dynamic-size-chart__variants');
      if (!this.variantsContainer) return;

      this.variantsContainer.addEventListener('click', this.handleVariantClick);

      const activeTab = this.querySelector('.dynamic-size-chart__variant.active');
      const defaultVariantId = activeTab?.dataset.variant
        || this.querySelector('.dynamic-size-chart__variant')?.dataset.variant;

      if (defaultVariantId) {
        this.selectVariant(defaultVariantId);
      }
    }

    disconnectedCallback() {
      this.variantsContainer?.removeEventListener('click', this.handleVariantClick);
    }

    handleVariantClick(event) {
      const variantTab = event.target.closest('.dynamic-size-chart__variant');
      if (!variantTab || !this.variantsContainer.contains(variantTab)) return;

      event.preventDefault();
      this.selectVariant(variantTab.dataset.variant);
    }

    selectVariant(variantId) {
      if (!variantId) return;

      this.querySelectorAll('.dynamic-size-chart__variant').forEach((tab) => {
        tab.classList.toggle('active', tab.dataset.variant === variantId);
      });

      this.querySelectorAll('.dynamic-size-chart__variant-content__item').forEach((item) => {
        item.classList.toggle('hidden', item.dataset.variant !== variantId);
      });
    }
  }

  customElements.define('dynamic-size-chart', DynamicSizeChart);
}